<bom-basemap
  [mapSteder$]="mapSteder$"
  [konfliktLayers$]="konfliktLayers$"
  [enableMeasurement]="enableMeasurement"
  [mapStedFokus$]="mapStedFokus$"
  [koordinatSted$]="koordinatSted$"
  [padding]="padding"
  [resetMap$]="resetMap$"
  (mapClick)="mapClickEvent$.next($event)"
>
  <ng-container map-overlay-top>
    <div class="overlay-sted" *ngIf="stedOplysninger || isLoading || stedOplysninger === null">
      <!-- Display this when loading data -->
      <ng-container *ngIf="isLoading">
        <div class="card-text">
          <bom-spinner size="small"></bom-spinner>
        </div>
      </ng-container>

      <!-- Display this when data is loaded but there is no results -->
      <ng-container *ngIf="stedOplysninger === null && !isLoading">
        <!-- Only show 'Ingen resultater' when sted betegnelse has actively been set to null as opposed to undefined -->
        <div class="card-text">
          <div class="row">{{ 'NoResultsMatchedSearch' | tekstresource }}</div>
        </div>
      </ng-container>

      <!-- Display this when data is loaded -->
      <ng-container *ngIf="stedOplysninger && !isLoading">
        <div class="row align-bottom">
          <div class="col">
            <div class="row">
              <div class="col col-md-8 col-adresse">
                <ng-container *ngIf="stedOplysninger.visningNavn.lastIndexOf(',') as index">
                  <div class="row">{{ stedOplysninger.visningNavn.substring(0, index) }}</div>
                  <div class="row">{{ stedOplysninger.visningNavn.substring(index + 1) }}</div>
                </ng-container>
              </div>
              <ng-container *ngIf="showGoToAddressDetailsButton">
                <div class="col">
                  <button
                    class="button button-unstyled scroll-to-details"
                    (click)="scrollToAddressDetailsElement()"
                  >
                    <span>
                      {{ 'Soegning.Map.GoToDetails' | tekstresource }} <br />
                      <svg class="icon-svg" focusable="false" aria-hidden="true">
                        <use xlink:href="#angle-arrow-down"></use>
                      </svg>
                    </span>
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-content select="[map-overlay-top]"></ng-content>
  </ng-container>
  <ng-container map-overlay-bottom>
    <ng-content select="[map-overlay-bottom]"></ng-content>
  </ng-container>
</bom-basemap>
<bom-modal [title]="'FlereEjendomme.Titel' | tekstresource" [isOpen$]="isMultipeBFEWarningOpen$">
  <ng-container bom-modal-content>
    <p>
      {{ 'FlereEjendomme.Tekst' | tekstresource }}
    </p>
  </ng-container>
</bom-modal>
